module.exports = __webpack_public_path__ + "static/SSHcPanel-568973302d3c39dec57565c8090cc4b2.png";